// Use new Theme
//import NewTheme from "./NewTheme";
import NewTheme from "@apeiros/react-styles/green/Theme";

export default NewTheme;


// Use classic apeiros Theme
//import ApeirosTheme from "@apeiros/react-styles/ApeirosTheme";
//
//export default ApeirosTheme;
